import { Radio } from "antd";
import styled from "styled-components";

export const RadioGroup = styled(Radio.Group)`
  display: flex;
  flex-direction: column;
  gap: 3px;

  .ant-radio-wrapper {
    margin-inline-end: 0px !important;
  }

  .ant-radio-wrapper span.ant-radio + * {
    padding-inline-start: 8px;
    padding-inline-end: 0px !important;
    width: 100%;
  }

  .ant-radio-label {
    width: 100%;
    padding-inline-end: 0 !important;
  }
`;
